import React, { useEffect, useState } from 'react';
import '../Users.css';
import Sidebar from '../../components/Sidebar';
import Buttons from '../../components/Button';
// import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../state/store';
import { setUsers, addUser, updateUser, setLoading as setUserLoading, setError as setUserError } from '../../state/slices/userSlice';
import { setVendors, setLoading as setVendorLoading, setError as setVendorError } from '../../state/slices/vendorSlice';
import { setShops, setLoading as setShopLoading, setError as setShopError } from '../../state/slices/shopSlice';
import {fetchUsers, fetchVendorByUserId, fetchShopsByVendorId} from '../../graphql/api/userApi';
import UserManagement from '../users/UserManagement';
import VendorManagement from '../users/VendorManagement';
import ShopManagement from '../users/ShopManagement';
import Loading from '../../components/Loading';
import { CREATE_USER, UPDATE_USER } from '../../graphql/userMutation';
import { useMutation } from '@apollo/client';
// import { GET_USERS } from '../../graphql/userQuery';
import AlertMessage from '../../components/AlertMessage';
import { LocationInput } from '../../interfaces/user';
import { useAuth } from "../../context/AuthContext";


import { createVendorApi, updateVendorApi, createShopApi, updateShopApi } from '../../graphql/api/userApi';

const VendorUserManagement: React.FC = () => {
  const dispatch = useDispatch();
  // const navigate = useNavigate();

  const users = useSelector((state: RootState) => state.user.users);
  const vendors = useSelector((state: RootState) => state.vendor.vendors);
  const shops = useSelector((state: RootState) => state.shop.shops);
  const isLoading = useSelector((state: RootState) => state.user.loading || state.vendor.loading || state.shop.loading);
  const error = useSelector((state: RootState) => state.user.error || state.vendor.error || state.shop.error);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [activeTab, setActiveTab] = useState<'user' | 'vendor' | 'shop'>('user');
  const [isEditing, setIsEditing] = useState(false);
  const [selections, setSelections] = useState({ userId: '', vendorId: '' });

  const [userForm, setUserForm] = useState({
    username: '', email: '', phoneNumber: '', role: 'user', status: 'active', password: '', gender: '', id: ''
  });

  const [vendorForm, setVendorForm] = useState({ businessName: '', email: '', phone: '', address: '', id: '' });

  const [shopForm, setShopForm] = useState({
    id: '', vendorId: '', shopName: '', shopLogo: '',
    location: { city: '', state: '', country: '' },
    createdAt: new Date().toISOString(), fromDate: '', toDate: ''
  });

  const [passwordError, setPasswordError] = useState('');
 const [createUser] = useMutation(CREATE_USER, {
  onCompleted: (data) => {
    dispatch(addUser(data.createUser)); // use correct response key
  }
});
const [updateUserMutation] = useMutation(UPDATE_USER, {
  onCompleted: (data) => {
    dispatch(updateUser(data.updateUser));
  }
});
const [alertMessage, setAlertMessage] = useState('');
const [alertType, setAlertType] = useState<'success' | 'error' | 'info' | 'warning'>('info');
const {currentUser} = useAuth();


  // Initialize users on component mount
  useEffect(() => {
    const fetchUserData = async () => {
      dispatch(setUserLoading(true));
      try {
        const users = await fetchUsers();
        const filteredUsers = users.filter(user => user.id === currentUser?.id);
        dispatch(setUsers(filteredUsers));
      } catch (err) {
        const msg = err instanceof Error ? err.message : 'Error fetching users';
        dispatch(setUserError(msg));
      } finally {
        dispatch(setUserLoading(false));
      }
    };

    if (currentUser?.id) {
      fetchUserData();
    }
  }, [dispatch, currentUser?.id]);

  // Fetch vendors when user selection changes and vendor tab is active
  useEffect(() => {
    const fetchVendorData = async () => {
      if (!selections.userId || activeTab !== 'vendor') return;

      dispatch(setVendorLoading(true));
      try {
        const vendor = await fetchVendorByUserId(selections.userId);
        if (!vendor){
          setAlertMessage('Vendors not found');
          setAlertType('error');
        } 
        dispatch(setVendors(vendor));
      } catch (err) {
        const msg = err instanceof Error ? err.message : 'Error fetching vendor';
        dispatch(setVendorError(msg));
      } finally {
        dispatch(setVendorLoading(false));
      }
    };

    fetchVendorData();
  }, [selections.userId, activeTab, dispatch]);

  // Fetch shops when vendor selection changes and shop tab is active
  useEffect(() => {
    const fetchShopData = async () => {
      if (!selections.vendorId || activeTab !== 'shop') return;
    
      dispatch(setShopLoading(true));
      try {
        const shops = await fetchShopsByVendorId(selections.vendorId);
         if (!shops){
          setAlertMessage('Shops not found');
          setAlertType('error');
        } 
        dispatch(setShops(shops));
      } catch (err) {
        const msg = err instanceof Error ? err.message : 'Error fetching shops';
        dispatch(setShopError(msg));
      } finally {
        dispatch(setShopLoading(false));
      }
    };

    fetchShopData();
  }, [selections.vendorId, activeTab, dispatch]);

    useEffect(() => {
      const fetchVendorsForUser = async () => {
        if (!selections.userId || activeTab !== 'shop') return;

        dispatch(setVendorLoading(true));
        try {
          const vendors = await fetchVendorByUserId(selections.userId); // 👈 This function should fetch vendors tied to a user
          dispatch(setVendors(vendors));
        } catch (err) {
          const msg = err instanceof Error ? err.message : 'Error fetching vendors';
          dispatch(setVendorError(msg));
        } finally {
          dispatch(setVendorLoading(false));
        }
      };

      fetchVendorsForUser();
    }, [selections.userId, activeTab]);

  // Reset vendor selection when user changes
  useEffect(() => {
    if (selections.userId) {
      setSelections(prev => ({ ...prev, vendorId: '' }));
    }
  }, [selections.userId]);

  // Reset alertMessage
  useEffect(() => {
  if (alertMessage) {
    const timer = setTimeout(() => {
      setAlertMessage('');
    }, 3000);
    return () => clearTimeout(timer);
  }
}, [alertMessage]);


  const resetForms = () => {
    setUserForm({ username: '', email: '', phoneNumber: '', role: 'user', status: 'active', password: '', gender: '', id: '' });
    setVendorForm({ businessName: '', email: '', phone: '', address: '', id: '' });
    setShopForm({
      id: '', vendorId: '', shopName: '', shopLogo: '',
      location: { city: '', state: '', country: '' },
      createdAt: new Date().toISOString(), fromDate: '', toDate: ''
    });
    setIsEditing(false);
  };

  const handleUserChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setUserForm({ ...userForm, [e.target.name]: e.target.value });
  };

  const handleVendorChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setVendorForm({ ...vendorForm, [e.target.name]: e.target.value });
  };

  const handleShopChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setShopForm({ ...shopForm, [e.target.name]: e.target.value });
  };

  const handleSelectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setSelections(prev => ({ ...prev, [name]: value }));
  };

// const handleUserSubmit = async (e: React.FormEvent) => {
//   e.preventDefault();

//   if (!isEditing && userForm.password !== (userForm as any).confirmPassword) {
//     setPasswordError('Passwords do not match');
//     return;
//   }

//   setPasswordError('');

//   try {
//     if (isEditing) {
//       await updateUserMutation({
//         variables: {
//           id: userForm.id,
//           username: userForm.username,
//           email: userForm.email,
//           phoneNumber: userForm.phoneNumber,
//           role: userForm.role,
//           status: userForm.status,
//           gender: userForm.gender,
//         }
//       });
//     } else {
//       await createUser({
//         variables: {
//           username: userForm.username,
//           email: userForm.email,
//           phoneNumber: userForm.phoneNumber,
//           role: userForm.role,
//           status: userForm.status,
//           password: userForm.password,
//           gender: userForm.gender,
//         }
//       });
//     }

//     // ✅ Show success message
//     setAlertMessage(isEditing ? 'User updated successfully' : 'User created successfully');
//     setAlertType('success');

//     // ✅ Reset form
//     setUserForm({
//       username: '',
//       email: '',
//       phoneNumber: '',
//       role: 'user',
//       status: 'active',
//       password: '',
//       gender: '',
//       id: ''
//     });

//   } catch (err) {
//     console.error('Mutation error:', err);
//     setAlertMessage('An error occurred while submitting');
//     setAlertType('error');
//   }
// };

const handleUserSubmit = async (
  e: React.FormEvent
) => {
  e.preventDefault();

  // Vendor user cannot create a new user
  if (!isEditing) {
    setAlertMessage(
      "You are not allowed to create a new user."
    );
    setAlertType("error");
    return;
  }

  setPasswordError("");

  try {
    await updateUserMutation({
      variables: {
        id: userForm.id,
        username: userForm.username,
        email: userForm.email,
        phoneNumber: userForm.phoneNumber,

        // IMPORTANT:
        // Do NOT send role from vendor side.
        // Existing role remains unchanged in backend.

        status: userForm.status,
        gender: userForm.gender,
      }
    });

    setAlertMessage(
      "User updated successfully"
    );

    setAlertType("success");

    resetForms();

  } catch (err) {

    console.error(
      "User update error:",
      err
    );

    setAlertMessage(
      "An error occurred while updating user"
    );

    setAlertType("error");
  }
};

const handleVendorSubmit = async (e: React.FormEvent) => {
  e.preventDefault();

 const { id, businessName, email, phone, address } = vendorForm;

const basePayload = { businessName, email, phone, address };

try {
  if (isEditing && id) {
    await updateVendorApi(id, basePayload);
    setAlertMessage("Vendor updated successfully");
  } else {
    if (!selections.userId) {
      setAlertMessage("Please select a user before creating a vendor.");
      setAlertType("error");
      return;
    }

    const payloadWithUserId = { ...basePayload, userId: selections.userId };
    await createVendorApi(payloadWithUserId);
    setAlertMessage("Vendor created successfully");
  }

  setAlertType("success");
  resetForms();

  if (selections.userId && activeTab === 'vendor') {
    const vendor = await fetchVendorByUserId(selections.userId);
    dispatch(setVendors(vendor));
  }

} catch (err) {
  console.error("Vendor mutation error:", err);
  setAlertMessage("An error occurred while submitting vendor");
  setAlertType("error");
}

};



const handleShopSubmit = async (e: React.FormEvent) => {
  e.preventDefault();

  console.log("Shop Form:", shopForm);

  const {
    id,
    shopName,
    shopLogo, // This might be a blob URL – not needed for upload
    location: { city, state, country },
  } = shopForm;

  const locationInput: LocationInput = {
    city: city ?? '',
    state: state ?? '',
    country: country ?? '',
  };

  // Extract actual file from file input
  const fileInput = document.getElementById('shopLogo') as HTMLInputElement;
  const shopLogoFile = fileInput?.files?.[0] ?? undefined;

  if (!shopLogoFile) {
    setAlertMessage("Image not found");
    setAlertType("error");
    return; // Prevent form submission or further execution
  }

  const payload = {
    shopName,
    vendorId: selections.vendorId,
    location: locationInput,
    fromDate: shopForm.fromDate,
    toDate: shopForm.toDate,
    shopLogoFile, // 👈 passed to fetch-based GraphQL upload
    shopLogo: null // Required in GraphQL input, but null when file used
  };

  try {
    if (isEditing && id) {
      const { vendorId, ...updateInput } = payload;
      await updateShopApi(id, updateInput); // Assuming update doesn't use file
      setAlertMessage("Shop updated successfully");
    } else {
      await createShopApi(payload);
      setAlertMessage("Shop created successfully");
    }

    setAlertType("success");
    resetForms();

    if (selections.vendorId && activeTab === 'shop') {
      const shops = await fetchShopsByVendorId(selections.vendorId);
      console.log("Shops after create:", shops);
      dispatch(setShops(shops));
    }

  } catch (err) {
    console.error("Shop mutation error:", err);
    setAlertMessage("An error occurred while submitting shop");
    setAlertType("error");
  }
};


  return (
    <div style={{ display: 'flex' }}>
      <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
      <div
        style={{
          flex: 1,
          marginLeft: isSidebarOpen ? (isMobile ? '0px' : '250px') : isMobile ? '0px' : '60px',
          transition: 'margin-left 0.3s ease',
          padding: '20px'
        }}
      >
        <div className="admin-user-management">
           <h2>User Management</h2>
          {alertMessage && <AlertMessage message={alertMessage} type={alertType} />}
          {isLoading && <Loading />}
        <br/><br/>
          <div className="admin-container">
            <div className="admin-form">
              <div className="form-tabs">
                <button
                  className={activeTab === 'user' ? 'active-tab' : ''}
                  onClick={() => setActiveTab('user')}
                >
                  User
                </button>
                <button
                  className={activeTab === 'vendor' ? 'active-tab' : ''}
                  onClick={() => setActiveTab('vendor')}
                >
                  Vendor
                </button>
                <button
                  className={activeTab === 'shop' ? 'active-tab' : ''}
                  onClick={() => setActiveTab('shop')}
                >
                  Shop
                </button>
              </div>

              <form onSubmit={
                activeTab === 'user' ? handleUserSubmit :
                  activeTab === 'vendor' ? handleVendorSubmit :
                    handleShopSubmit
              }>
                {activeTab === 'user' && (
                  <>
                    <div className="form-row">
                      <div className="form-group">
                        <label htmlFor="username">User Name</label>
                        <input
                          type="text"
                          id="username"
                          name="username"
                          value={userForm.username}
                          onChange={handleUserChange}
                          className="user_form-control"
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="phoneNumber">Phone Number</label>
                        <input
                          type="text"
                          id="phoneNumber"
                          name="phoneNumber"
                          value={userForm.phoneNumber}
                          onChange={handleUserChange}
                          className="user_form-control"
                          required
                        />
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          value={userForm.email}
                          onChange={handleUserChange}
                          className="user_form-control"
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="status">Status</label>
                        <select
                          id="status"
                          name="status"
                          value={userForm.status}
                          onChange={handleUserChange}
                          className="user_form-control"
                          required
                        >
                          <option value="active">Active</option>
                          <option value="inactive">Inactive</option>
                        </select>
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input
                          type="password"
                          id="password"
                          name="password"
                          value={userForm.password}
                          onChange={handleUserChange}
                          className="user_form-control"
                          required={!isEditing}
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="confirmPassword">Confirm Password</label>
                        <input
                          type="password"
                          id="confirmPassword"
                          name="confirmPassword"
                          value={(userForm as any).confirmPassword || ''}
                          onChange={handleUserChange}
                          className="user_form-control"
                          required={!isEditing}
                        />
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label htmlFor="gender">Gender</label>
                        <select
                          id="gender"
                          name="gender"
                          value={userForm.gender}
                          onChange={handleUserChange}
                          className="user_form-control"
                        >
                          <option value="">Select Gender</option>
                          <option value="male">Male</option>
                          <option value="female">Female</option>
                          <option value="other">Other</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor="role">Role</label>
                        <select
                          id="role"
                          name="role"
                          value={userForm.role}
                          onChange={handleUserChange}
                          className="user_form-control"
                          required
                        >
                 
                          <option value="vendor">Vendor</option>
                        </select>
                      </div>
                    </div>

                    {passwordError && <div className="error" style={{ color: "red" }}>{passwordError}</div>}
                  </>
                )}

                {activeTab === 'vendor' && (
                  <>
                    <div className="form-row">
                      <div className="form-group">
                        <label htmlFor="userId">Select User</label>
                        <select
                          id="userId"
                          name="userId"
                          value={selections.userId}
                          onChange={handleSelectionChange}
                          className="user_form-control"
                          required
                        >
                          <option value="">-- Select User --</option>
                          {users
                            .filter(user => ['vendor', 'shopowner'].includes(user.role))
                            .map(user => (
                              <option key={user.id} value={user.id}>
                                {user.username}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor="businessName">Vendor Name</label>
                        <input
                          type="text"
                          id="businessName"
                          name="businessName"
                          value={vendorForm.businessName}
                          onChange={handleVendorChange}
                          className="user_form-control"
                          required
                        />
                      </div>
                    </div>
                    <div className='form-row'>
                      <div className="form-group">
                        <label htmlFor="phone">Phone</label>
                        <input
                          type="text"
                          id="phone"
                          name="phone"
                          value={vendorForm.phone}
                          onChange={handleVendorChange}
                          className="user_form-control"
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          value={vendorForm.email}
                          onChange={handleVendorChange}
                          className="user_form-control"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group">
                        <label htmlFor="address">Vendor Address</label>
                        <input
                          type="text"
                          id="address"
                          name="address"
                          value={vendorForm.address}
                          onChange={handleVendorChange}
                          className="user_form-control"
                          required
                        />
                      </div>
                    </div>
                  </>
                )}

                {activeTab === 'shop' && (
                  <>
                    <div className="form-row">
                      <div className="form-group">
                        <label htmlFor="userId">Select User</label>
                        <select
                          id="userId"
                          name="userId"
                          value={selections.userId}
                          onChange={handleSelectionChange}
                          className="user_form-control"
                          required
                        >
                          <option value="">-- Select User --</option>
                          {users
                            .filter(user => ['vendor', 'shopowner'].includes(user.role))
                            .map(user => (
                              <option key={user.id} value={user.id}>
                                {user.username}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor="vendorId">Select Vendor</label>
                        <select
                          id="vendorId"
                          name="vendorId"
                          value={selections.vendorId}
                          onChange={handleSelectionChange}
                          className="user_form-control"
                          required
                          disabled={!selections.userId}
                        >
                          <option value="">-- Select Vendor --</option>
                          {vendors
                            .filter(vendor => vendor.userId === selections.userId)
                            .map(vendor => (
                              <option key={vendor.id} value={vendor.id}>
                                {vendor.businessName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label htmlFor="shopName">Shop Name</label>
                        <input
                          type="text"
                          id="shopName"
                          name="shopName"
                          value={shopForm.shopName}
                          onChange={handleShopChange}
                          className="user_form-control"
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="city">City</label>
                        <input
                          id="city"
                          name="city"
                          value={shopForm.location.city}
                          onChange={(e) => setShopForm(prev => ({
                            ...prev,
                            location: {
                              ...prev.location,
                              city: e.target.value
                            }
                          }))}
                          className="user_form-control"
                          required
                        />
                      </div>
                    </div>
                    <div className='form-row'>
                      <div className="form-group">
                        <label htmlFor="state">State</label>
                        <input
                          id="state"
                          name="state"
                          value={shopForm.location.state}
                          onChange={(e) => setShopForm(prev => ({
                            ...prev,
                            location: {
                              ...prev.location,
                              state: e.target.value
                            }
                          }))}
                          className="user_form-control"
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="country">Country</label>
                        <input
                          id="country"
                          name="country"
                          value={shopForm.location.country}
                          onChange={(e) => setShopForm(prev => ({
                            ...prev,
                            location: {
                              ...prev.location,
                              country: e.target.value
                            }
                          }))}
                          className="user_form-control"
                          required
                        />
                      </div> </div>
                    <div className="form-row">
                      <div className="form-group">
                        <label htmlFor="fromDate">From Date</label>
                        <input
                          type="date"
                          id="fromDate"
                          name="fromDate"
                          value={shopForm.fromDate}
                          onChange={handleShopChange}
                          className="user_form-control"
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="toDate">To Date</label>
                        <input
                          type="date"
                          id="toDate"
                          name="toDate"
                          value={shopForm.toDate}
                          onChange={handleShopChange}
                          className="user_form-control"
                          required
                          min={shopForm.fromDate}
                        />
                      </div>
                    </div>
                    <div className='form-row'>
                      <div className="form-group">
                        <label htmlFor="shopLogo">Shop Image</label>
                        <input
                          type="file"
                          id="shopLogo"
                          name="shopLogo"
                          onChange={(e) => {
                            if (e.target.files?.[0]) {
                              setShopForm(prev => ({
                                ...prev,
                                shopLogo: URL.createObjectURL(e.target.files![0])
                              }));
                            }
                          }}
                          className="user_form-control"
                        />
                      </div>
                    </div>
                  </>
                )}
                {error && <div className="error" style={{ color: 'red' }}>{error}</div>}

                <div className="form-actions">
                  {isEditing ? (
                    <Buttons
                      text="Update"
                      type="button"
                      variant="update"
                      className="ml-2"
                      onClick={(e: any) => {
                        e.preventDefault();
                        if (activeTab === 'user') handleUserSubmit(e);
                        else if (activeTab === 'vendor') handleVendorSubmit(e);
                        else handleShopSubmit(e);
                      }}
                    />
                  ) : (
                    <Buttons
                      text="Add"
                      type="button"
                      variant="add"
                      className="ml-2"
                      onClick={(e: any) => {
                        e.preventDefault();
                        if (activeTab === 'user') handleUserSubmit(e);
                        else if (activeTab === 'vendor') handleVendorSubmit(e);
                        else handleShopSubmit(e);
                      }}
                    />
                  )}
                  <Buttons
                    text="Cancel"
                    type="button"
                    onClick={resetForms}
                    variant="cancel"
                    className="ml-2"
                  />
                </div>
              </form>
            </div>

            <div className="admin-table">
              {activeTab === 'user' && (
                <UserManagement
                  isEditing={isEditing}
                  setIsEditing={setIsEditing}
                  setActiveTab={setActiveTab}
                  setUserForm={setUserForm}
                  users={users}
                  setUsers={(u) => dispatch(setUsers(u))}
                />
              )}
              {activeTab === 'vendor' && (
                <VendorManagement
                  users={users}
                  vendors={vendors}
                  setVendors={(v) => dispatch(setVendors(v))}
                  setActiveTab={setActiveTab}
                  setIsEditing={setIsEditing}
                  setVendorForm={setVendorForm}
                  setSelections={setSelections}
                />
              )}
              {activeTab === 'shop' && (
                <ShopManagement
                  vendors={vendors}
                  shops={shops}
                  setShops={(s) => dispatch(setShops(s))}
                  setActiveTab={setActiveTab}
                  setIsEditing={setIsEditing}
                  setShopForm={setShopForm}
                  setSelections={setSelections}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorUserManagement;